ui-bank-search {
  --map-height-mobile: calc(100vh - 75px);
  --map-height-desktop: 600px;
  --filter-height: 110px;

  display: block;
  overflow: hidden;
  position: relative;

  .bank-search__intro-wrapper {
    width: 100vw;
    height: 100%;
    margin: 7.1875rem calc(50% - 50vw) 0;
    background-image: var(--url-map-blurred);

    @include breakpoint($desktop) {
      width: auto;
      margin: 0;
    }
  }

  .bank-search__map-wrapper {
    height: var(--map-height-mobile);

    @include breakpoint($desktop) {
      height: var(--map-height-desktop);
    }
  }

  ui-bank-search-map {
    position: absolute;
    top: 0;
    left: 0;
  }

  ui-bank-search-map-overlay,
  ui-bank-search-bank-overlay {
    position: absolute;
    width: 100%;
    inset: 0;

    @include breakpoint($desktop) {
      inset: 0 auto;
    }
  }
}
